<template>
  <!-- 预售活动管理 -->
  <div class="promMan">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="getTableData('refresh')"
      :crumbsList="['促销管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd"
          v-if="buttonVisibility.Promotion"
        >
          添加促销活动</el-button
        >
        <el-button
          type="danger"
          @click="handleDel()"
          v-if="buttonVisibility.delete"
        >删除</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="search.startDate"
          style="width: 140px; margin-right: 10px"
          placeholder="选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="search.endDate"
          style="width: 140px; margin-right: 10px"
          placeholder="选择结束日期"
        >
        </el-date-picker>
        <label class="label">分类：</label>
        <el-select
          v-model="search.type"
          placeholder="活动类型"
          style="width: 100px; margin-right: 10px"
          clearable
        >
          <el-option label="全部分类" value=""></el-option>
          <!-- $store.state.PROM_TYPE -->
          <el-option
            v-for="item in promtype"
            :key="item.Code"
            :label="item.Name"
            :value="item.Code"
          ></el-option>
        </el-select>
        <label class="labeljs">状态：</label>
        <el-select
          v-model="search.status"
          placeholder="状态"
          style="width: 100px; margin-right: 10px"
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="已上架" value="2"></el-option>
          <el-option label="未上架" value="1"></el-option>
        </el-select>
        <span class="labeljs">检索：</span>
        <el-input
          style="width: 140px; margin-right: 10px"
          clearable
          placeholder="输入标题"
          v-model="search.Title"
        >
        </el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="getTableData('search')"
          v-if="buttonVisibility.search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <!-- @selection-change="selectionChange" -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      @selection-change="selectionChange"
      tooltip-effect="dark"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="55">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="ActivityId"
        align="center"
        show-overflow-tooltip
        label="活动编号"
      >
      </el-table-column>
      <el-table-column
        prop="Title"
        align="center"
        show-overflow-tooltip
        label="标题"
      >
      </el-table-column>
      <el-table-column
        prop="AddTime"
        label="创建时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="StartTime"
        label="开始时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="EndTime"
        label="结束时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="Status"
        show-overflow-tooltip
        label="状态"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.Status == 2">已启用</el-tag>
          <el-tag type="warning" v-else-if="scope.row.Status == 1"
            >已禁用</el-tag
          >
          <el-tag type="info" v-else-if="scope.row.Status == 0">已删除</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.Status == 1 && buttonVisibility.edit"
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-if="scope.row.Status == 2 && buttonVisibility.details"
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleEdit(scope.row)"
            >查看</el-button
          >
          <el-button
            v-if="scope.row.Status == 1 && buttonVisibility.shelf"
            type="success"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 2)"
            >上架</el-button
          >
          <el-button
            v-if="scope.row.Status == 2 && buttonVisibility.unshelf"
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 1)"
            >下架</el-button
          >
          <!-- <el-button
            v-if="scope.row.Status == 1"
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope, 0)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>该界面管理商城中的促销活动</p>
        <p>新增：打开新增促销活动表单</p>
        <p>下架：禁用该促销活动，禁用后该活动可进行编辑</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "promMan",
  data() {
    return {
      /**用户信息 */
      entId: "",

      /**搜索表单 */
      search: {
        status: "99",
        name: "", //查询关键词
        type: "",
        startDate: "",
        endDate: "",
      },

      /**表格数据 */
      tableData: [],
      selectedList: [],
      promtype: [],

      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,

      /**使用说明 */
      explain: false,
    };
  },
  computed: {
    ...mapState(['buttonPermissions']),
    // 按钮权限
    buttonVisibility() {
      const buttonsLimit = this.buttonPermissions?.['促销活动'] || [] ;
      // console.log('促销活动buttonsLimit', buttonsLimit);
      return {
        Promotion: buttonsLimit.includes('添加促销活动'),
        delete: buttonsLimit.includes('删除'),
        search: buttonsLimit.includes('搜索'),
        edit: buttonsLimit.includes('编辑'),
        details: buttonsLimit.includes('详情'),
        shelf: buttonsLimit.includes('上架'),
        unshelf: buttonsLimit.includes('下架')
      }
    }
  },
  mounted() {
    this.entId = localStorage.getItem("entId");
    this.getTableData("refresh");
    this.getpromType();
  },
  activated() {
    // 看缓存中是否有刷新的标识
    let boo = window.localStorage.getItem("refresh");
    if (boo) {
      this.getTableData("refresh");
      // 删除该字段
      window.localStorage.removeItem("refresh");
    }
  },
  methods: {
    /**店家添加商品 */
    handleAdd() {
      // this.addDialog = true
      this.$router.push({
        path: "promForm",
        query: {
          type: "Add",
          id: "",
        },
      });
    },

    /**获取数据 */
    getTableData(type = "") {
      if (type == "refresh") {
        this.currPage = 1;
        this.search.status = "99";
        this.search.name = ""; //查询关键词
        this.search.type = "";
        this.search.startDate = "";
        this.search.endDate = "";
      } else if (type == "search") {
        this.currPage = 1;
      }

      this.$request({
        url: "/Management/ActivityAdmin/GetActivityList",
        method: "post",
        data: {
          type: this.search.type, //默认传空
          val: this.search.Title, //查询关键字
          status: this.search.status, //状态99 全部
          startDate: this.search.startDate,
          endDate: this.search.endDate,
          pageIndex: this.currPage,
          pageSize: this.pageSize,
        },
      })
        .then((res) => {
          if (res.success) {
            this.tableData = res.dataList;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**获取促销分类 */
    getpromType() {
      this.$request({
        url: "/Activity/GetActivityTypeApi",
        method: "post",
        data: {
          activityType: "Promotion",
        },
      })
        .then((res) => {
          if (res.success) {
            this.promtype = res.dataList;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },

    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**点击编辑 */
    handleEdit(row) {
      this.$router.push({
        path: "promForm",
        query: {
          type: "Update",
          id: row.ActivityId,
        },
      });
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**删除 */
    handleDel() {
      let row = {};
      if (this.selectedList.length == 1) {
        row = this.selectedList[0];
        if (row.Status == 1) {
          this.changeStatus(row, 0);
        } else {
          this.$message({
            message: "启用状态下不允许删除",
            type: "warning",
          });
        }
      } else {
        this.$message({
          message: "只能删除一条数据",
          type: "warning",
        });
      }
    },
    /**状态修改，0 删除 1 禁用 2 启用 */
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let msgType = "info";
      if (status == 1) {
        msg = "确定下架吗?";
        msgType = "warning";
      } else if (status == 2) {
        msg = "确定上架吗?";
        msgType = "success";
      } else if (status == 0) {
        msg = "确定删除吗?";
        msgType = "error";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: msgType,
      })
        .then(() => {
          this.$request({
            method: "post",
            url: "/Management/ActivityAdmin/AuditActivityStatusApi",
            data: {
              activityId: row.ActivityId,
              status,
            },
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.promMan {
  width: 100%;
  height: 100%;
}
</style>